import React, {useState} from "react";
import {NavLink} from "react-router-dom";
import {NavHashLink} from "react-router-hash-link";
import {Trans, useTranslation} from "react-i18next";

import {ContainerValue, DialogWrapper} from "components/containers";
import {Button, IcoEdit, IcoEye, TextPlain, TitleH2, TitleH3, TitleH4, TrashIcon,} from "components/generic";
import {theme} from "styles/theme";
import {PublishButton, TogglePublish, WrapperContainer} from "./styles";
import {IHousesShotInfo} from "interfaces/intarfaces";
import {HOST_ROOMEDIT_ROUTE, STUDENT_ROOMINFO_ROUTE} from "utils/constants";
import {SpokenLanguages} from "pages/ProfileUser/SimpleComponents";
import {useContextHost} from "context/ContextHost";
import {useContextHospi} from "context/ContextHospi";
import Modal from "components/Modal";
import {DialogPublish} from "pages/HostHouseRegistration/DialogPublish";

export const RoomCard: React.FC<{
  house: IHousesShotInfo;
}> = ({ house }) => {
  const { t, i18n } = useTranslation("hostrooms");
  const { userProfile } = useContextHospi();
  const { deleteRoom, publishRoom } = useContextHost();
  const [checked, setChecked] = useState(house.house_status === "PUBLISHED");
  const [showModal, setShowModal] = useState<number>(0);

  const dateLine = (value: string | undefined): string => {
    if (!value) return "";
    const dt = new Date(value);
    return `${("0" + dt.getDate()).slice(-2)}-${(
      "0" +
      (dt.getMonth() + 1)
    ).slice(-2)}-${dt.getFullYear()}`;
  };

  const removeRoom = () => {
    if (house.house_id) {
      // REQUEST FOR DELETE
      deleteRoom(house.house_id);
      setShowModal(0);
    }
  };

  const sendRequest = (isOk: boolean) => {
    if (isOk) {
      publishRoom(house.house_id!);
      setChecked(true);
    } else setChecked(false);
    setShowModal(0);
  };

  const changePublishStatus = () => {
    if (!!house.published_at?.length) {
      publishRoom(house.house_id!);
      setChecked(false);
    } else setShowModal(2);
  };

  const closeDlg = () => {
    showModal === 2 && setChecked(false);
    setShowModal(0);
  };

  return (
    <ContainerValue style={{ margin: 0 }}>
      <WrapperContainer>
        <div className="header">
          <div>
            <NavLink to={`/${i18n.language}${STUDENT_ROOMINFO_ROUTE.slice(5)}` + `/${house.house_id}`}>
              <TitleH2>{house.title}</TitleH2>
            </NavLink>
            <div className="min-width">
              <NavLink to={`/${i18n.language}${STUDENT_ROOMINFO_ROUTE.slice(5)}` + `/${house.house_id}`}>
                <IcoEye
                  size="1em"
                  style={{ marginLeft: "1rem" }}
                  color={theme.colors.thirdly}
                />
              </NavLink>
              <NavLink to={`/${i18n.language}${HOST_ROOMEDIT_ROUTE.slice(5)}` + `/${house.house_id}`}>
                <IcoEdit
                  size="1em"
                  style={{ marginLeft: "1rem" }}
                  color={theme.colors.thirdly}
                />
              </NavLink>
              {house.house_status !== "RENTED" && (
                <TrashIcon
                  size="1em"
                  style={{ marginLeft: "1rem" }}
                  color={theme.colors.thirdly}
                  onClick={() => setShowModal(1)}
                />
              )}
            </div>
          </div>
          {house.rent_dates.length ?
            (house.rent_dates.map((item, j) => (
              <Trans
                t={t}
                i18nKey={`rooms.rented`}
                values={{
                  date_from: dateLine(item.check_in_date),
                  date_to: dateLine(item.check_out_date),
                }}
                parent={TitleH4}
                style={{ color: theme.colors.primary }}
                key={j}
              />
            ))) : ''}
          {house.house_status !== "RENTED" && (
            <TitleH4>{`${t("availabilityPrices.items.extraDate.from")} ${dateLine(
              house.available_from
            )} ${t("availabilityPrices.items.extraDate.until")} ${house.available_to === '2101-01-01' ? t("anyDate").toLowerCase() : dateLine(house.available_to)}`}</TitleH4>
          )}
        </div>
        <div className="mainContent">
          <div>
            <TitleH3>{t("preferredTenat.title")}</TitleH3>
            <p>{`${t("preferredTenat.startAge")} ${house.min_tennant_age} ${t(
              "preferredTenat.untilAge"
            )} ${house.max_tennant_age}`}</p>
            <p>{house.gender === "any" &&
              t("preferredTenat.item.gender.any")
            }
              {house.gender === "female" &&
                t("preferredTenat.item.gender.female")
              }
              {house.gender === "male" &&
                t("preferredTenat.item.gender.male")
              } </p>
            <SpokenLanguages items={house.spoken_languages ?? []} />
          </div>
          <PublishButton>
            {checked === false ? t("preferredTenat.buttonPublish") : t("preferredTenat.buttonUnPublish")}
            {house.house_status === "RENTED" ? (
              <NavHashLink
                to={`/${i18n.language}` + HOST_ROOMEDIT_ROUTE.slice(5) + `/${house.house_id}#dateInAv`}
              >
                <TogglePublish />
              </NavHashLink>
            ) : (
              <label>
                <input
                  type="checkbox"
                  checked={checked}
                  onChange={() => {
                    setChecked((prev) => !prev);
                    changePublishStatus();
                  }}
                />
                <div className="slider round" />
              </label>
            )}
          </PublishButton>
        </div>
      </WrapperContainer>
      {showModal > 0 && (
        <Modal isShow={!!showModal} handleClose={closeDlg}>
          {showModal === 1 && (
            <DialogWrapper>
              <TitleH2 className="titleDel">{t("deleteRoom.title")}</TitleH2>
              <TextPlain className="textDel">{t("deleteRoom.text")}</TextPlain>
              <div className="buttons">
                <Button
                  normal
                  onClick={() => setShowModal(0)}
                  className="butCancel"
                >
                  {t("deleteRoom.buttonCancel")}
                </Button>
                <Button danger onClick={removeRoom} className="butDel">
                  {t("deleteRoom.buttonDelete")}
                </Button>
              </div>
            </DialogWrapper>
          )}
          {showModal === 2 && (
            <DialogPublish
              requestPublish={sendRequest}
              isVerified={userProfile?.verification_status === "verified"}
              isProfileCompleted={userProfile?.is_profile_complete ?? false}
            />
          )}
        </Modal>
      )}
    </ContainerValue>
  );
};
